import { UPDATE_JOB_APPLICATION } from '../../endpoints';
import { JobApplication } from '../../types/jobs';
import makeAuthenticatedRequest from '../base-api';

interface UpdateJobApplicationResponse {
  success: boolean;
  message?: string;
  jobApplication?: JobApplication;
}

const updateJobApplicationApi = async (
  payload: JobApplication
): Promise<UpdateJobApplicationResponse> => {
  try {
    const response = await makeAuthenticatedRequest(UPDATE_JOB_APPLICATION, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      if (result.message) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result;
  } catch (error) {
    console.error('Update job application failed:', error);
    throw error;
  }
};

export { updateJobApplicationApi, type UpdateJobApplicationResponse };
